import UserMobileUpdateModal from "./UserMobileUpdateModal"

export default UserMobileUpdateModal
